import { FC, ReactNode, useCallback, useLayoutEffect, useState } from "react";

interface IProps {
  children: ReactNode;
  PreviewComponent?: FC<{ onClosePreview: () => void }>;
  disablePreview?: boolean;
}

const QuestionPreview = ({
  children,
  PreviewComponent,
  disablePreview,
}: IProps) => {
  const hasPreviewComponent = !!PreviewComponent;
  const [isShowingPreview, setIsShowingPreview] = useState(hasPreviewComponent);

  const handlePreview = useCallback((value: boolean) => {
    setIsShowingPreview(() => value);

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useLayoutEffect(
    () => handlePreview(hasPreviewComponent),
    [hasPreviewComponent]
  );

  if (isShowingPreview && hasPreviewComponent && !disablePreview) {
    return (
      <div className="flex flex-1 items-center justify-center bg-white px-4 z-50 text-3xl min-h-[550px] md:px-0">
        <PreviewComponent onClosePreview={() => handlePreview(false)} />
      </div>
    );
  }

  return children;
};

export { QuestionPreview };
